import React from 'react';
import { StopCircle, User, Calendar } from 'feather-icons-react/build/IconComponents';
import Select from 'react-select';
import { useSelector, useDispatch } from 'react-redux';
import { selectCustomerData } from '../../core/redux/customer/selectors';
import { selectProcessStatuses } from '../../core/redux/status/selectors';
import { selectProductionFilters } from './store/selectors';
import { actions as productionActions, fetchProductionsWithFilters } from './store/slice';
import { Link } from 'react-router-dom';
import { useTransformOptions } from 'Core/hooks';

const { setCustomer, setStatus, setStartDate, setEndDate } = productionActions;

const ProductionFilter = () => {
  const dispatch = useDispatch();
  const customers = useSelector(selectCustomerData);
  const statuses = useSelector(selectProcessStatuses);
  const {
    customer: selectedCustomer,
    status: selectedStatus,
    startDate,
    endDate,
  } = useSelector(selectProductionFilters);

  const customerOptions = useTransformOptions(
    customers,
    'id',
    'customerName',
    '0',
    'Select Customer',
  );
  const statusOptions = useTransformOptions(statuses, 'status', 'status', '', 'Select Status');

  const handleCustomerChange = selected => {
    dispatch(setCustomer(selected));
  };

  const handleStatusChange = selected => {
    dispatch(setStatus(selected));
  };

  const onSearch = () => {
    dispatch(fetchProductionsWithFilters());
  };

  return (
    <div className="card visible" id="filter_inputs" style={{ display: 'block' }}>
      <div className="card-body pb-0">
        <div className="row">
          {/* <div className="col-lg-4 col-sm-6 col-12">
            <div className="input-blocks">
              <User className="info-img" />
              <Select
                options={customerOptions}
                value={selectedCustomer}
                onChange={handleCustomerChange}
                className="img-select"
                classNamePrefix="react-select"
                placeholder="Choose Customer"
              />
            </div>
          </div> */}
          <div className="col-lg-4 col-sm-6 col-12">
            <div className="input-blocks">
              <StopCircle className="info-img" />
              <Select
                className="img-select"
                options={statusOptions}
                value={selectedStatus}
                onChange={handleStatusChange}
                classNamePrefix="react-select"
                placeholder="Choose Status"
              />
            </div>
          </div>
          {/* <div className="col-lg-2 col-sm-6 col-12">
            <div className="input-blocks">
              <Calendar className="info-img" />
              <input
                type="date"
                className="form-control"
                value={startDate || ''}
                onChange={e => dispatch(setStartDate(e.target.value))}
                placeholder="Start Date"
              />
            </div>
          </div>
          <div className="col-lg-2 col-sm-6 col-12">
            <div className="input-blocks">
              <Calendar className="info-img" />
              <input
                type="date"
                className="form-control"
                value={endDate || ''}
                onChange={e => dispatch(setEndDate(e.target.value))}
                placeholder="End Date"
              />
            </div>
          </div> */}

          <div className="col-lg-4 col-sm-6 col-12 ms-auto">
            <div className="input-blocks">
              <Link className="btn btn-filters ms-auto" onClick={onSearch}>
                {' '}
                <i data-feather="search" className="feather-search" /> Search{' '}
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProductionFilter;
